import React from 'react';
import { hintComponent } from './ConfigurationField';
import { ConfigurationTooltipWrapper } from './ConfigurationTooltipWrapper';
import { humanizeName } from '../ChargerConfigurationHelper';

export function ConfigurationFieldLabel({ label, description, status }) {
  return (
    <div className="parameter-label-container">
      <div className="label-marker-container">
        <ConfigurationTooltipWrapper
          trigger={<div className={`parameter-status-marker ${status}`} />}
          message={humanizeName(status)}
        />
        {label}
        {
          description
        && (
          <ConfigurationTooltipWrapper
            trigger={hintComponent}
            message={description}
          />
        )
        }
      </div>
    </div>
  );
}
